var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED7AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house",
    x1: 14,
    x2: 50,
    y1: 17,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11D48"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C2D12",
    d: "M10 31 32 13l22 18-5 6-17-14-17 14-5-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house)",
    d: "M16 31h32v23H16z",
    rx: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7ED",
    d: "M24 42c0-5 4-9 8-9s8 4 8 9v12H24V42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDBA74",
    d: "M13 47c7-4 31-4 38 0v7H13v-7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA580C",
    d: "M18 48c6-2 22-2 28 0v4H18v-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBed);
export default __webpack_public_path__ + "static/media/house-bed.c09e1d97890a940956367401b571b556.svg";
export { ForwardRef as ReactComponent };